import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { memo } from "../util/index.js";
export function nextElected(instanceId, api) {
  return memo(instanceId, function () {
    return api.query.staking.erasStakers ? api.derive.session.indexes().pipe( // only populate for next era in the last session, so track both here - entries are not
    // subscriptions, so we need a trigger - currentIndex acts as that trigger to refresh
    switchMap(function (_ref) {
      var currentEra = _ref.currentEra;
      return api.query.staking.erasStakers.keys(currentEra);
    }), map(function (keys) {
      return keys.map(function (_ref2) {
        var _ref2$args = _slicedToArray(_ref2.args, 2),
            accountId = _ref2$args[1];

        return accountId;
      });
    })) : api.query.staking.currentElected();
  });
}
/**
 * @description Retrieve latest list of validators
 */

export function validators(instanceId, api) {
  return memo(instanceId, function () {
    return (// Sadly the node-template is (for some obscure reason) not comprehensive, so while the derive works
      // in all actual real-world deployed chains, it does create some confusion for limited template chains
      combineLatest([api.query.session ? api.query.session.validators() : of([]), api.query.staking ? api.derive.staking.nextElected() : of([])]).pipe(map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            validators = _ref4[0],
            nextElected = _ref4[1];

        return {
          nextElected: nextElected.length ? nextElected : validators,
          validators: validators
        };
      }))
    );
  });
}